import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "displaybox"
};
const _hoisted_2 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.darr, (item, index) => {
    return _openBlock(), _createBlock(_component_el_tooltip, {
      class: "box-item",
      effect: "dark",
      content: item.name,
      placement: "top",
      key: index
    }, {
      default: _withCtx(() => [_createElementVNode("span", {
        class: _normalizeClass([item.icon, {
          'active': index === $data.dIndex
        }]),
        onClick: $event => $options.handleClick(item, index)
      }, null, 10, _hoisted_2)]),
      _: 2
    }, 1032, ["content"]);
  }), 128))]);
}